import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';

import ConfirmActionModal from './ConfirmActionModal';

const RuleDuplicateConfirmModal = ({ onConfirm, onClose, rules, ...props }) => (
    <ConfirmActionModal
        confirmationPhrase="duplicate"
        imgSrc="/assets/images/duplicateIconColor.svg"
        onConfirm={onConfirm}
        onClose={onClose}
        title="Duplicate Rule(s)?"
        {...props}
    >
        Are you sure you want to duplicate these rule(s)?
        <ul>
            {rules.map(({ id, name }) => (
                <li key={id}>{name}</li>
            ))}
        </ul>
    </ConfirmActionModal>
);


RuleDuplicateConfirmModal.defaultProps = {
    onClose:   () => {},
    onConfirm: () => {},
    rules:     []
};

RuleDuplicateConfirmModal.propTypes = {
    onConfirm: func,
    onClose:   func,
    rules:     arrayOf(shape({
        name: string
    }))
};

export default RuleDuplicateConfirmModal;
